export enum PromotionType {
  PIG_DEAL = 'PIG_DEAL',
  OFFER = 'OFFER',
  DISCOUNT = 'DISCOUNT'
}
